function StaticExample() {
  return null;
}

export default StaticExample;
